import api from './api';

export const customerService = {
  // Create new customer
  createCustomer: (customerData) => api.post('/customers', customerData),

  // Get all customers
  getAllCustomers: (params) => api.get('/customers', { params }),

  // Get customer by ID
  getCustomerById: (id) => api.get(`/customers/${id}`),

  // Update customer
  updateCustomer: (id, customerData) => api.put(`/customers/${id}`, customerData),

  // Delete customer
  deleteCustomer: (id) => api.delete(`/customers/${id}`),

  // Upload Aadhar card
  uploadAadhar: (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/customers/${customerId}/upload/aadhar`, formData);
  },

  // Upload PAN card
  uploadPan: (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/customers/${customerId}/upload/pan`, formData);
  },

  // Delete customer file
  deleteCustomerFile: (customerId, fileType) => api.delete(`/customers/${customerId}/files/${fileType}`)
};